// edit-brand.component.ts
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { BrandService } from 'app/services/brand/brand.service';
import { BrandDto } from 'app/models/brand-dto';
import { ImageUrlPipe } from 'app/modules/admin/pipe/image-url.pipe';
import { GalleryPickerComponent } from 'app/shared/gallery-picker/gallery-picker.component';
import { ImageFallbackDirective } from 'app/modules/admin/directives/ImageFallbackDirective';
import { ImageItem } from 'app/services/gallery/gallery.service';

@Component({
  selector: 'app-edit-brands',
  standalone: true,
imports: [
  CommonModule,
  ReactiveFormsModule,
  ImageUrlPipe,
  GalleryPickerComponent,
  ImageFallbackDirective
],  templateUrl: './edit-brands.component.html',
  styleUrls: ['./edit-brands.component.scss']
})
export class EditBrandsComponent implements OnInit {
  brandForm!: FormGroup;
  submitted = false;
  isLoading = true;
  loadingMessage = 'جاري تحميل بيانات البراند...';
  currentBrandSlug: string = '';
  isUpdating = false;
  selectedFile: File | null = null;
  existingLogoUrl!: string;
logoPreview: string = '';
removeExistingLogo = false;

isGalleryModalOpen = false;
selectedPhotos: ImageItem[] = [];

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private brandService: BrandService
  ) {}

  ngOnInit() {
    this.initializeForm();
    this.loadBrandData();
  }

  private initializeForm() {
    this.brandForm = this.fb.group({
      code: ['', [
        Validators.required, 
        Validators.minLength(1), 
        Validators.maxLength(20),
        Validators.pattern('^[0-9]+$')
      ]],
      arName: ['', [
        Validators.required, 
        Validators.minLength(2),
        Validators.maxLength(100)
      ]],
      enName: ['', [
        Validators.required, 
        Validators.minLength(2),
        Validators.maxLength(100)
      ]],
      logo: [null],
      top: [false, [Validators.required]],
      slug: ['', [
        Validators.required,
        Validators.pattern('^[a-z0-9-]+$')
      ]],
      status: [true, [Validators.required]]
    });
  }

  private loadBrandData(): void {
    const brandSlug = this.route.snapshot.paramMap.get('slug');
    
    if (!brandSlug) {
      console.error('❌ Invalid brand Slug:', brandSlug);
      alert('❌ معرّف البراند غير صالح');
      this.router.navigate(['/admin/brands']);
      location.reload()
      return;
    }
    this.currentBrandSlug = brandSlug;
    console.log(brandSlug);
    this.brandService.getBrandBySlug(brandSlug).subscribe({
      next: (response) => {
        console.log('✅ Brand data loaded:', response);
        
        if (response.success) {
          const brand = response;
          this.patchBrandData(brand);
          this.isLoading = false;
        } else {
          console.error('❌ No brand data found');
          alert('❌ لم يتم العثور على بيانات البراند');
          this.router.navigate(['/admin/brands']);
        }
      },
      error: (error: HttpErrorResponse) => {
        console.error('❌ Error loading brand:', error);
        this.isLoading = false;
        this.handleLoadError(error);
      }
    });
   
  }

  // private patchBrandData(brand: BrandDto): void {
  //   console.log('🟡 Patching brand data:', brand);
    
  //   this.brandForm.patchValue({
  //     code: brand.code || '',
  //     arName: brand.ar_name || '',
  //     enName: brand.en_name || '',
  //     top: brand.top !== undefined ? brand.top : false,
  //     slug: brand.slug || '',
  //     status: brand.status !== undefined ? brand.status : true
  //   });

  //   // حفظ رابط اللوجو الحالي إذا كان موجوداً
  //   if (brand.logo) {
  //     this.existingLogoUrl = brand.logo;
  //   }

  //   console.log('✅ Brand data patched successfully');
  // }

  private patchBrandData(brand: BrandDto): void {
  this.brandForm.patchValue({
    code: brand.code || '',
    arName: brand.ar_name || '',
    enName: brand.en_name || '',
    top: brand.top !== undefined ? brand.top : false,
    slug: brand.slug || '',
    status: brand.status !== undefined ? brand.status : true
  });

  if (brand.logo) {
    this.existingLogoUrl = brand.logo;
    this.logoPreview = brand.logo;
  } else {
    this.existingLogoUrl = '';
    this.logoPreview = '';
  }
}

  // الدوال المساعدة للوصول إلى عناصر الفورم
  get f(): { [key: string]: AbstractControl } {
    return this.brandForm.controls;
  }

  isFieldInvalid(fieldName: string): boolean {
    const field = this.brandForm.get(fieldName);
    return !!(field && field.invalid && (field.dirty || field.touched));
  }

  getFieldError(fieldName: string): string {
    const field = this.brandForm.get(fieldName);
    if (field?.errors) {
      if (field.errors['required']) {
        return 'هذا الحقل مطلوب';
      }
      if (field.errors['minlength']) {
        return `الحد الأدنى للحروف هو ${field.errors['minlength'].requiredLength}`;
      }
      if (field.errors['maxlength']) {
        return `الحد الأقصى للحروف هو ${field.errors['maxlength'].requiredLength}`;
      }
      if (field.errors['pattern']) {
        if (fieldName === 'code') {
          return 'يجب أن يحتوي الكود على أرقام فقط';
        } else if (fieldName === 'slug') {
          return 'يجب أن يحتوي الرابط على أحرف إنجليزية صغيرة وأرقام وشرطة فقط';
        }
      }
    }
    return '';
  }

  // معالجة اختيار ملف اللوجو
onLogoSelected(event: any): void {
  const file = event.target.files[0];
  if (!file) return;

  if (!file.type.match('image.*')) {
    alert('❌ يرجى اختيار ملف صورة فقط');
    return;
  }

  if (file.size > 2 * 1024 * 1024) {
    alert('❌ حجم الصورة يجب أن يكون أقل من 2MB');
    return;
  }

  this.selectedFile = file;
  this.brandForm.patchValue({ logo: file });
  this.brandForm.markAsDirty();

  const reader = new FileReader();
  reader.onload = () => {
    this.logoPreview = reader.result as string;
  };
  reader.readAsDataURL(file);

  const fileInput = document.getElementById('logo') as HTMLInputElement;
  if (fileInput) {
    fileInput.value = '';
  }
}

  // إزالة اللوجو
removeLogo(): void {
  this.selectedFile = null;
  this.existingLogoUrl = '';
  this.logoPreview = '';
  this.removeExistingLogo = true;

  this.brandForm.patchValue({ logo: null });
  this.brandForm.markAsDirty();

  const fileInput = document.getElementById('logo') as HTMLInputElement;
  if (fileInput) {
    fileInput.value = '';
  }
}

  // تحديث البراند
  onSubmit(): void {
    this.submitted = true;

    if (!this.brandForm.valid) {
      this.markFormGroupTouched(this.brandForm);
      alert('❌ يوجد أخطاء في النموذج. راجع الحقول المطلوبة.');
      return;
    }

    if (!this.hasFormChanged()) {
      alert('⚠️ لم تقم بإجراء أي تغييرات على البيانات');
      return;
    }

    this.updateBrand();
  }

  private hasFormChanged(): boolean {
    return this.brandForm.dirty || this.selectedFile !== null;
  }

  private updateBrand(): void {
    this.isUpdating = true;
    this.loadingMessage = 'جاري تحديث البراند...';

    const brandData = this.brandForm.value;

    console.log('🟡 Updating brand with data:', brandData);

    this.brandService.updateBrand(this.currentBrandSlug, brandData).subscribe({
      next: (response) => {
        console.log('✅ Brand updated successfully:', response);
        this.isUpdating = false;
        
        if (response.success) {
          alert('✅ تم تحديث البراند بنجاح!');
          this.router.navigate(['/admin/brands']);
        } else {
          alert('❌ ' + ('حدث خطأ أثناء تحديث البراند'));
        }
      },
      error: (error: HttpErrorResponse) => {
        console.error('❌ Error updating brand:', error);
        this.isUpdating = false;
        this.handleError(error);
      }
    });

    // Temporary mock success
    // setTimeout(() => {
    //   console.log('✅ Brand updated successfully (mock)');
    //   this.isUpdating = false;
    //   alert('✅ تم تحديث البراند بنجاح!');
    //   this.router.navigate(['/admin/brands']);
    // }, 1500);
  }

  private prepareBrandData(): FormData {
    const formData = new FormData();
    const formValue = this.brandForm.value;
    
    formData.append('code', formValue.code.trim());
    formData.append('arName', formValue.arName.trim());
    formData.append('enName', formValue.enName.trim());
    formData.append('top', formValue.top.toString());
    formData.append('slug', formValue.slug.trim());
    formData.append('status', formValue.status.toString());

    if (this.selectedFile) {
      formData.append('logo', this.selectedFile);
    }

    return formData;
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      } else {
        control?.markAsTouched();
      }
    });
  }

  private handleLoadError(error: HttpErrorResponse): void {
    let errorMessage = '❌ حدث خطأ في تحميل بيانات البراند';
    
    if (error.status === 404) {
      errorMessage = '❌ البراند غير موجود';
    } else if (error.status === 0) {
      errorMessage = '❌ تعذر الاتصال بالخادم';
    }
    
    alert(errorMessage);
    this.router.navigate(['/admin/brands']);
  }

  private handleError(error: HttpErrorResponse): void {
    let errorMessage = '❌ حدث خطأ أثناء تحديث البراند';
    
    if (error.error && error.error.errors) {
      const validationErrors = error.error.errors;
      const errorMessages = [];
      
      for (const field in validationErrors) {
        if (validationErrors.hasOwnProperty(field)) {
          errorMessages.push(...validationErrors[field]);
        }
      }
      
      if (errorMessages.length > 0) {
        errorMessage = '❌ ' + errorMessages.join('\n');
      }
    } else if (error.error && error.error.message) {
      errorMessage = '❌ ' + error.error.message;
    } else if (error.status === 404) {
      errorMessage = '❌ البراند غير موجود';
    } else if (error.status === 409) {
      errorMessage = '❌ كود البراند موجود مسبقاً';
    }
    
    alert(errorMessage);
  }

  onReset(): void {
    if (confirm('هل تريد إعادة تعيين التغييرات؟')) {
      this.loadBrandData();
      this.selectedFile = null;
      this.submitted = false;
    }
  }

  onCancel(): void {
    if (this.hasFormChanged()) {
      if (confirm('هل تريد إلغاء التغييرات؟ سيتم فقدان جميع التعديلات.')) {
        this.router.navigate(['/admin/brands']);
      }
    } else {
      this.router.navigate(['/admin/brands']);
    }
  }

  // توليد slug تلقائي من الاسم الإنجليزي
  generateSlug(): void {
    const enName = this.brandForm.get('enName')?.value;
    if (enName) {
      const slug = enName
        .toLowerCase()
        .replace(/[^a-z0-9 -]/g, '') // إزالة الرموز غير المرغوب فيها
        .replace(/\s+/g, '-') // استبدال المسافات بشرطة
        .replace(/-+/g, '-') // استبدال الشرطات المتعددة بشرطة واحدة
        .substring(0, 50);
      
      this.brandForm.patchValue({ slug });
    }
  }

  // التحقق من صحة الكود
  validateCode(): void {
    const codeControl = this.brandForm.get('code');
    if (codeControl?.value) {
      const code = codeControl.value;
      if (!/^[0-9]+$/.test(code)) {
        codeControl.setErrors({ pattern: true });
      } else {
        if (codeControl.errors?.['pattern']) {
          delete codeControl.errors['pattern'];
          if (Object.keys(codeControl.errors).length === 0) {
            codeControl.setErrors(null);
          }
        }
      }
    }
  }

  // التحقق من صحة الـ slug
  validateSlug(): void {
    const slugControl = this.brandForm.get('slug');
    if (slugControl?.value) {
      const slug = slugControl.value;
      if (!/^[a-z0-9-]+$/.test(slug)) {
        slugControl.setErrors({ pattern: true });
      } else {
        if (slugControl.errors?.['pattern']) {
          delete slugControl.errors['pattern'];
          if (Object.keys(slugControl.errors).length === 0) {
            slugControl.setErrors(null);
          }
        }
      }
    }
  }

  // دالة للتحقق إذا كان النموذج محمل
  isFormLoaded(): boolean {
    return !this.isLoading && this.currentBrandSlug != "";
  }

getLogoUrl(): string {
  return this.logoPreview || '';
}
openGalleryModal(): void {
  this.isGalleryModalOpen = true;
}

closeGalleryModal(): void {
  this.isGalleryModalOpen = false;
}

onGalleryImagesChange(images: ImageItem[]): void {
  this.selectedPhotos = images || [];

  const firstImage = this.selectedPhotos[0];

  if (!firstImage) return;

  this.selectedFile = null;
  this.removeExistingLogo = false;
  this.logoPreview = firstImage.url;
  this.existingLogoUrl = firstImage.url;

  this.brandForm.patchValue({
    logo: Number(firstImage.id)
  });

  this.brandForm.markAsDirty();
  this.closeGalleryModal();
}
}
